<template>
  <div class="mutil-video">
    <VideoUpload 
      v-for="(file, index) in videoList" 
      :key="index"
      :file="file"
      @video="file"
      :limitSize="limitSize"
      @del="delFileList(index)"
      @upload-success="(url) => updateFileList(index, url)"
    />
    <VideoUpload 
    @change="handleChange"
    />
  </div>
</template>

<script>

import VideoUpload from './video.vue'
export default {
  model: {
    prop: 'videos',
    event: 'change'
  },
  data() {
    return {
      videoList: [],
      errmsgIns: null
    }
  },
  components: {
    VideoUpload
  },
  props: {
    videos: {
      type: Array,
      default: ()=> {
        return []
      }
    },
    limitNum: {
      type: Number,
      default: 1
    },
    limitSize: {
      type: Number,
      default: 500 // 500MB
    }
  },
  watch: {
    videos: {
      handler(v) {
        this.videoList = [...(v || [])]
      },
      immediate: true
    }
  },
  methods: {
    handleChange(file, fileList) {
      const existNum = this.videoList.length;
      if(existNum > this.limitNum -1 ) {
        console.log('视频数量已达上线');
        return this.$message.error('视频数量已达到上限,请先移除超限视频');
      }
      this.videoList.push(file);
    },
    delFileList(index) {
      this.videoList.splice(index,1);
      this.$emit('change', this.videoList)
    },
    updateFileList(index, val) {
      //  替换元素
      this.$set(this.videoList, index, val)
      this.$emit('change', this.videoList);
    },
  }
}
</script>

<style lang="scss" scoped>
.mutil-video{
  display: flex;
  align-items: center;
}

</style>
